export default __webpack_public_path__ + "static/media/FlyingFrog13.f4eb3e12.png";